import React, { useState } from "react";
import { FiPrinter } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { jsPDF } from "jspdf"; // Import jsPDF
import { saveAs } from "file-saver"; // Import FileSaver.js
import ClearBillModel from "./ClearBillModel";

export default function InvoiceModal({ visible, data, onClose }) {
  const [newvisible, setNewvisible] = useState(false);
  const [order_id, setOrder_id] = useState(null);
  const [balance, setBalance] = useState(null);

  const formatPrice = (price) => {
    return `$${Number(price).toLocaleString("en-US", {
      minimumFractionDigits: 2,
    })}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const orderStatus = () => {
    if (data.order_status === "pending") {
      return "<span style='color: #ff9800;'>Pending</span>";
    } else if (
      data.order_status === "complete" &&
      data.total_amount == data.total_paid_amount
    ) {
      return "<span style='color: #4caf50;'>Complete</span>";
    } else if (
      data.order_status === "complete" &&
      data.total_amount !== data.total_paid_amount
    ) {
      return "<span style='color: #f44336;'>Discount</span>";
    }
    return "";
  };
  const generatePDF = async () => {
    try {
      const products = data.product_names.split(",").map((product, index) => ({
        name: product,
        quantity: data.product_quantities.split(",")[index],
        packPrice: data.purchase_price_pack.split(",")[index],
        totalPrice: (
          data.product_quantities.split(",")[index] *
          data.purchase_price_pack.split(",")[index]
        ).toFixed(2),
      }));

      const htmlContent = `
      <!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <title>Invoice</title>
    <style>
      body { 
        font-family: Arial, sans-serif; 
        margin: 0; 
        padding: 40px; 
        color: #333;
      }
      .header { 
        margin-bottom: 40px;
      }
      .header h1 {
        font-size: 32px;
        margin: 0;
        color: #333;
      }
      .header-right {
        float: right;
        text-align: right;
      }
      .address-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin: 30px 0;
      }
      .address-box {
        background-color: #008CBA;
        color: white;
        padding: 10px;
        margin-bottom: 10px;
      }
      .address-content {
        padding: 10px 0;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        margin: 30px 0;
      }
      .table th {
        background-color: #008CBA;
        color: white;
        padding: 10px;
        text-align: left;
      }
      .table td {
        padding: 10px;
        border-bottom: 1px solid #ddd;
      }
      .notes {
        margin: 30px 0;
      }
      .notes-header {
        background-color: #008CBA;
        color: white;
        padding: 10px;
        margin-bottom: 10px;
      }
      .totals {
        float: right;
        width: 300px;
        margin-top: 20px;
      }
      .totals-row {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        border-bottom: 1px solid #ddd;
      }
      .footer {
        text-align: center;
        margin-top: 50px;
        color: #666;
        font-size: 12px;
      }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="header-right">
        <div>Date: ${formatDate(data.created_at)}</div>
        <div>Invoice Number: #${data.order_id.slice(0, 8)}</div>
        <div>Status: ${data.order_status}</div>
      </div>
      <h1>Shiva Toys</h1>
      <div>Main Market Kurukshetra</div>
    </div>

    <div class="address-grid">
      <div>
        <div class="address-box">To</div>
        <div class="address-content">
          Shiva Toys<br>
          Main Market<br>
          Kurukshetra<br>
          Contact: ${data.contact || "N/A"}
        </div>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Description</th>
          <th>Unit Cost</th>
          <th>Quantity</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        ${products
          .map(
            (product) => `
          <tr>
            <td>${product.name}</td>
            <td>${formatPrice(product.packPrice)}</td>
            <td>${product.quantity}</td>
            <td>${formatPrice(product.totalPrice)}</td>
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>

    <div class="notes">
      <div class="notes-header">Notes</div>
      <div class="notes-content">
        Thank you for your business! Payment is due within 15 days.
      </div>
    </div>

    <div class="totals">
      <div class="totals-row">
        <span>Subtotal</span>
        <span>${formatPrice(
          data.total_amount / data.product_names.split(",")?.length
        )}</span>
      </div>
      <div class="totals-row">
        <span>${orderStatus()}</span>
        <span>${formatPrice(
          data.total_amount / data.product_names.split(",")?.length -
            data.total_paid_amount / data.product_names.split(",")?.length
        )}</span>
      </div>
      <div class="totals-row">
        <span>Total</span>
        <span>${formatPrice(
          data.total_paid_amount / data.product_names.split(",")?.length
        )}</span>
      </div>
    </div>

    <div class="footer">
      Invoice generated by Shiva Toys Management System
    </div>
  </body>
</html>
      `;

      const doc = new jsPDF();

      doc.setFontSize(18);
      doc.text(htmlContent);

      // Save the PDF using FileSaver.js
      const pdfBlob = doc.output("blob");
      saveAs(pdfBlob, `Invoice_${data.order_id.slice(0, 8)}.pdf`);
    } catch (error) {
      console.error("PDF generation error:", error);
      alert("Error: Failed to generate PDF");
    }
  };

  const handlePrint = async () => {
    await generatePDF();
  };
  function HandleClearBill(balance, id) {
    setBalance(balance);
    setOrder_id(id);
    setNewvisible(true);
  }
  function onCloseNew() {
    setBalance(null);
    setOrder_id(null);
    setNewvisible(false);
  }
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-4/5 max-w-4xl max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <div className="flex items-center gap-4">
              <button
                onClick={onClose}
                className="hover:bg-gray-100 p-2 rounded-full"
              >
                <MdCancel className="w-5 h-5" />
              </button>
              <h2 className="text-xl font-semibold">Invoice Details</h2>
            </div>
            <button
              onClick={handlePrint}
              className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
            >
              <FiPrinter className="w-4 h-4" />
              <span>Download PDF</span>
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">
            {/* Invoice Header */}
            <div className="flex justify-between items-start mb-8">
              <div>
                <p className="text-gray-500 text-sm">Invoice ID</p>
                <p className="text-red-500 font-medium">
                  #{data.order_id.slice(-8, -1)}
                </p>
              </div>
              <div className="flex gap-3">
                <span
                  className={`px-4 py-2 rounded-full text-white font-medium capitalize ${
                    data.order_status === "pending"
                      ? "bg-yellow-500"
                      : data.order_status === "complete"
                      ? "bg-green-500"
                      : "bg-red-500"
                  }`}
                >
                  {data.order_status}
                </span>
                {data.order_status === "pending" && (
                  <button
                    onClick={() =>
                      HandleClearBill(
                        Number(
                          data.total_amount /
                            data.product_names.split(",")?.length
                        ) -
                          Number(
                            data.total_paid_amount /
                              data.product_names.split(",")?.length
                          ),
                        data.order_id
                      )
                    }
                    className="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600"
                  >
                    Clear Bill
                  </button>
                )}
              </div>
            </div>

            {/* Customer Info */}
            <div className="grid grid-cols-2 gap-8 mb-8">
              <div>
                <p className="text-gray-500 text-sm mb-1">Issue Date</p>
                <p className="font-medium">{formatDate(data.created_at)}</p>
              </div>
              <div>
                <p className="text-gray-500 text-sm mb-1">Shiva Toys</p>
                <p className="text-gray-500 text-sm mb-1">
                  Main Market Kurukshetra
                </p>
                <p className="text-gray-500 text-sm">98456521</p>
              </div>
            </div>

            {/* Items */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold mb-4">Items</h3>
              <div className="space-y-4">
                {data.product_names.split(",")?.map((product, index) => (
                  <div key={index} className="bg-gray-50 p-4 rounded-lg">
                    <div className="grid grid-cols-4 gap-4">
                      <div>
                        <p className="font-semibold text-green-600">Name</p>
                        <p>{product}</p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm">Quantity</p>
                        <p>{data.product_quantities.split(",")[index]} qty</p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm">Pack Price</p>
                        <p>RS. {data.purchase_price_pack.split(",")[index]}</p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm">Total Price</p>
                        <p>
                          Rs.{" "}
                          {(
                            data.product_quantities.split(",")[index] *
                            data.purchase_price_pack.split(",")[index]
                          ).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Summary */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Summary</h3>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Total Quantity</span>
                    <span>{data.total_quantity} Packs</span>
                  </div>
                  <div className="pt-3 border-t border-gray-200 space-y-3">
                    <div className="flex justify-between">
                      <span className="font-semibold">Total Amount</span>
                      <span className="font-semibold">
                        {formatPrice(
                          data.total_amount /
                            data.product_names.split(",")?.length
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold">Total Paid Amount</span>
                      <span className="font-semibold">
                        {formatPrice(
                          data.total_paid_amount /
                            data.product_names.split(",")?.length
                        )}
                      </span>
                    </div>
                    {data.order_status == "pending" && (
                      <div className="flex justify-between">
                        <span className="font-semibold">Balance</span>
                        <span className="font-semibold">
                          {formatPrice(
                            Number(
                              data.total_amount /
                                data.product_names.split(",")?.length
                            ) -
                              Number(
                                data.total_paid_amount /
                                  data.product_names.split(",")?.length
                              )
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {newvisible && (
        <ClearBillModel
          visible={newvisible}
          onCancel={onCloseNew}
          balance={balance}
          order_id={order_id}
        />
      )}
    </>
  );
}
